export const BgBenefits = () => {
  return (
    <>
      <div className="benefits-info">
        <h2 className="benefits-title">Why choose us?</h2>
        <p className="benefits-description">
          A large part of our role is choosing which particular coffees will be
          featured in our range. This means working closely with the best coffee
          growers to give you a more impactful experience on every level.
        </p>
      </div>
    </>
  );
};
